import { render, staticRenderFns } from "./DashboardInfoWidgets.vue?vue&type=template&id=3990aa0c&scoped=true"
import script from "./DashboardInfoWidgets.vue?vue&type=script&lang=js"
export * from "./DashboardInfoWidgets.vue?vue&type=script&lang=js"
import style0 from "./DashboardInfoWidgets.vue?vue&type=style&index=0&id=3990aa0c&prod&lang=scss"
import style1 from "./DashboardInfoWidgets.vue?vue&type=style&index=1&id=3990aa0c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3990aa0c",
  null
  
)

export default component.exports